<script setup lang="ts">
import { IconProps } from './IconProps';

withDefaults(defineProps<IconProps>(), {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  background: 'none',
  color: 'currentColor',
  opacity: 1,
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :fill="background"
  >
    <!-- Board -->
    <rect
      x="3"
      y="3.5"
      width="18"
      height="11"
      rx="1.5"
      :stroke="color"
      stroke-width="1.6"
      :stroke-opacity="opacity"
    />
    <!-- Pole -->
    <line
      x1="12"
      y1="14.5"
      x2="12"
      y2="21"
      :stroke="color"
      stroke-width="1.6"
      stroke-linecap="round"
      :stroke-opacity="opacity"
    />
    <!-- Base -->
    <line
      x1="9"
      y1="21"
      x2="15"
      y2="21"
      :stroke="color"
      stroke-width="1.6"
      stroke-linecap="round"
      :stroke-opacity="opacity"
    />
  </svg>
</template>
